import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { ConfigurationProvider } from '../../providers/configuration/configuration';
import { Role } from '../../models/roles'
import { GlobalVars } from '../../app/app.environment';
import { version } from '../../app/app.constants';


@IonicPage()
@Component({
  selector: 'page-configuration',
  templateUrl: 'configuration.html',
})
export class ConfigurationPage {

  public Role = Role;

  public sms;
  public smsSubscription;
  
  public pagesConfig: any = {};
  public pagesConfigObservable;

  version = version;
  
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public configuration: ConfigurationProvider,
    public globalVars: GlobalVars,
  ) {
    this.pagesConfig.stateEnabled = false;
    this.pagesConfig.historyConfig = false;

    this.smsSubscription = this.configuration.getSMS().subscribe(sms => this.sms = sms);
    
    this.pagesConfigObservable = this.configuration.getPagesConfig().subscribe(config => {
      if(config != null) {
        this.pagesConfig = config
      }
    })
  }

  ionViewWillLeave() {
    if(this.smsSubscription && !this.smsSubscription.closed) this.smsSubscription.unsubscribe();
  }

  toggleSMS() {
    this.configuration.setSMS(this.sms);
  }

  toggleState() {
    this.configuration.setPagesConfig(this.pagesConfig)
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration.ts